import type { PropsWithChildren } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useAuth } from '@/providers/useAuth';

function AuthPendingState() {
  return (
    <div className="empty-state">
      <div>
        <p className="page-hero__eyebrow">Loading</p>
        <h1>Restoring your session</h1>
        <p>Checking your admin access and assigned environments.</p>
      </div>
    </div>
  );
}

export function RequireAuth({ children }: PropsWithChildren) {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <AuthPendingState />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return children;
}

export function PublicOnlyRoute({ children }: PropsWithChildren) {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return <AuthPendingState />;
  }

  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return children;
}